module.exports = __webpack_public_path__ + "img/winner4.fc575162.png";